import { AsyncPipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatError } from '@angular/material/form-field';
import { MatList, MatListItem } from '@angular/material/list';
import { Router } from '@angular/router';

import { ChangeResponsiblesComponent } from 'src/app/components/change-responsibles/change-responsibles.component';
import { Organization } from 'src/app/models/organization';
import { State } from 'src/app/models/states';
import { UserNamePipe } from 'src/app/pipes/user-name.pipe';
import { AzureIdStatusPipe } from 'src/app/pipes/azure-id-status.pipe';

@Component({
  selector: 'app-audit-responsibles',
  templateUrl: './audit-responsibles.component.html',
  styleUrls: ['./audit-responsibles.component.scss'],
  imports: [
    UserNamePipe,
    AzureIdStatusPipe,
    AsyncPipe,
    MatCard,
    FormsModule,
    ReactiveFormsModule,
    MatCardContent,
    MatList,
    MatListItem,
    MatError,
    MatButton
  ]
})
export class AuditResponsiblesComponent {
  dialog = inject(MatDialog);
  router = inject(Router);

  readonly form = input.required<UntypedFormGroup>();
  readonly editable = input.required<boolean>();
  readonly organizations = input.required<Organization[]>();
  readonly save = output();

  chkError(formName: string) {
    const field = this.form().controls[formName];
    return field && field.errors && field.touched;
  }

  openDialog() {
    this.dialog.open(ChangeResponsiblesComponent, {
      data: {
        formGroup: this.form(),
        organizations: this.organizations()
      }
    });
  }

  completeResponsibles() {
    this.form().get('status')!.setValue(State.PENDING);
    this.save.emit();
  }

  showCompleteResponsibles(): boolean {
    const state = this.form().value.status;
    return this.form().valid && state !== State.PENDING && state !== State.FINALYSETTLED && state !== State.SETTLED;
  }
}
